.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
  background: var(--color-overlay-backdrop);
}

.palette {
  position: fixed;
  /* Not vertically centred. A palette pinned near the top keeps its position
   * as the result count changes, which matters because the user is reading the
   * first row while still typing — a list that recentres on every keystroke
   * moves the row they are looking at. */
  top: 12vh;
  left: 50%;
  z-index: var(--z-palette);
  display: flex;
  flex-direction: column;
  width: calc(100vw - var(--space-7));
  max-width: 560px;
  max-height: min(60vh, 520px);
  overflow: hidden;
  background: var(--color-surface-raised);
  border: var(--border-width-thin) solid var(--color-border-default);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-high);
  transform: translateX(-50%);
}

.inputRow {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex: none;
  height: 44px;
  padding: 0 var(--space-4);
  border-bottom: var(--border-width-thin) solid var(--color-border-default);
}

.inputIcon {
  flex: none;
  color: var(--color-text-tertiary);
}

.input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  background: none;
  border: 0;
  font-size: var(--text-md);
  color: var(--color-text-primary);
}

.input:focus {
  /* The palette itself is the focused surface; a ring around the input inside
   * it would be a second box inside a box. */
  outline: none;
}

.input::placeholder {
  color: var(--color-text-tertiary);
}

.list {
  flex: 1 1 auto;
  padding: var(--space-2);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.group + .group {
  margin-top: var(--space-2);
  padding-top: var(--space-2);
  border-top: var(--border-width-thin) solid var(--color-border-default);
}

.groupLabel {
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-tertiary);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  /* The option is a <button>, so it needs the width stated: a button sizes to
   * its content, and a half-width row in a full-width list looks broken when
   * it highlights. */
  width: 100%;
  height: var(--row-height);
  text-align: start;
  padding: 0 var(--space-3);
  border-radius: var(--radius-sm);
  font-size: var(--text-base);
  color: var(--color-text-primary);
  cursor: pointer;
  user-select: none;
}

/* The active row is marked with a fill *and* an accent rule on its leading
 * edge. Colour alone would be the §8 failure, and this row has no glyph to
 * carry the state. */
.itemActive {
  background: var(--color-surface-selected);
  box-shadow: inset 2px 0 0 var(--color-accent-emphasis);
}

.itemIcon {
  display: inline-flex;
  flex: none;
  justify-content: center;
  width: 16px;
  color: var(--color-text-tertiary);
}

.itemActive .itemIcon {
  color: var(--color-accent-fg);
}

.itemLabel {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.noResults {
  padding: var(--space-6) var(--space-3);
  text-align: center;
  font-size: var(--text-base);
  color: var(--color-text-secondary);
}
